import { PlannedShipment } from "inbounds/InboundTypes";
import { getLoadedPlannedShipment } from "inbounds/steps/InboundStepSelectors";
import { getIsSpd } from "inbounds/utils/shippingMethodUtils";
import { createSelector } from "reselect";
import { selectIsForwardingPlan } from "inbounds/store/selectors/plan/selectIsForwardingPlan";
import { selectIsOneNodeHubSupportedMerchant, selectIsMultiNodeZBPFlow } from "common/user/UserSelectors";
import { selectIsLoadedShipmentWarehousePrepEnabled } from "inbounds/store/selectors/shipments";

/**
 * Determines whether Box Content Labels (BCL) with prep are enabled for the current inbound flow.
 *
 * This selector returns true in two cases:
 *
 * 1. When ALL of the following conditions are met:
 *    - The shipping method is NOT SPD (Small Parcel Delivery)
 *    - EITHER the shipment is a forwarding plan OR the merchant is a one-node hub supported merchant
 *
 * 2. OR when the following conditions are met:
 *    - The merchant is using Multi-Node Zone-Based Placement (ZBP) flow
 *    - The selected warehouse supports prep services
 *
 * This logic ensures that BCL prep is only enabled in appropriate workflows where the
 * necessary warehouse capabilities and shipping methods are available.
 */
export const selectIsBclPrepEnabledForFlow = createSelector(
  getLoadedPlannedShipment,
  selectIsForwardingPlan,
  selectIsOneNodeHubSupportedMerchant,
  selectIsMultiNodeZBPFlow,
  selectIsLoadedShipmentWarehousePrepEnabled,
  (
    plannedShipment: PlannedShipment,
    isForwardingPlan: boolean,
    isOneNodeHubSupportedMerchant: boolean,
    isMultiNodeZBPFlow: boolean,
    isPrepWarehouse: boolean
  ) =>
    plannedShipment &&
    !getIsSpd(plannedShipment.shippingMethod) &&
    (isForwardingPlan || isOneNodeHubSupportedMerchant || (isMultiNodeZBPFlow && isPrepWarehouse))
);
